export const initFormatters = (locale) => {
    const formatters = {
    // add your formatter functions here
    };
    return formatters;
};
